export default __webpack_public_path__ + "static/media/062-no flash.778c2563.svg";